import React, { Fragment, useEffect, useState } from 'react';
import { Patient } from '../../store/types/patient';
import { getPatientAndRelationPatients } from './utils';
import { track } from '../../tracking';
import { FAMILY_MEMBERS_ID_TO_NAME } from '../../constants';
import AddRelationsModal from './AddRelationsModal';
import { PtListItemViewOnly, PtListItemViewOnlyContent } from './PtListItem';

export const RelationsInEditPatient: React.FC<{ pid: string }> = ({ pid }) => {
    const [patient, setPatient] = useState<Patient>();
    const [relatedPatients, setRelatedPatients] = useState<Patient[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        getPatientDetails();
    }, []);

    const getPatientDetails = async () => {
        const patientAndRelationPatients = await getPatientAndRelationPatients(pid);
        if (!patientAndRelationPatients) {
            track('ERROR', { on: 'getPatientAndRelationPatients' });
            return;
        }
        const { patient, relationPatients } = patientAndRelationPatients;
        setPatient(patient);
        setRelatedPatients(relationPatients);
    };

    const toggleIsModalOpen = () => {
        setIsModalOpen(!isModalOpen);
        if (isModalOpen) getPatientDetails();
    };

    return (
        <Fragment>
            <div className="mt-16 space-y-4">
                <p className="text-neutral-3 font-700 text-14">Related profiles</p>
                <div className="space-y-6">
                    {relatedPatients.map((pt) => {
                        const rid = patient?.relations?.find((i) => i.pid === pt.id)?.rid || '';
                        return (
                            <div className="flex space-x-8">
                                <div className="flex items-center px-12 py-8 bg-darwin-neutrals-50 rounded-8">
                                    <PtListItemViewOnly pt={pt} />
                                    <PtListItemViewOnlyContent pt={pt} className="pl-8" />
                                </div>
                                <div className="px-12 py-7 border rounded-8 border border-darwin-neutral_new-200 flex items-center">
                                    <p className="text-13 text-darwin-neutrals-1000">
                                        {FAMILY_MEMBERS_ID_TO_NAME[rid] || '-'}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                    <div>
                        <button
                            className="flex items-center space-x-4 px-8 py-6"
                            onClick={toggleIsModalOpen}
                        >
                            <p>
                                <svg
                                    viewBox="0 0 12 12"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-12 h-12 fill-darwin-accent-bright-blue-800"
                                >
                                    <path d="M6.60938 1.45312V5.51562H10.6719C11.002 5.51562 11.2812 5.79492 11.2812 6.125C11.2812 6.48047 11.002 6.73438 10.6719 6.73438H6.60938V10.7969C6.60938 11.1523 6.33008 11.4062 6 11.4062C5.64453 11.4062 5.39062 11.1523 5.39062 10.7969V6.73438H1.32812C0.972656 6.73438 0.71875 6.48047 0.71875 6.125C0.71875 5.79492 0.972656 5.51562 1.32812 5.51562H5.39062V1.45312C5.39062 1.12305 5.64453 0.84375 6 0.84375C6.33008 0.84375 6.60938 1.12305 6.60938 1.45312Z" />
                                </svg>
                            </p>
                            <p className="text-12 font-700 text-darwin-accent-bright-blue-800">
                                Add / Edit Relations
                            </p>
                        </button>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <AddRelationsModal
                    pid={pid}
                    closeMe={toggleIsModalOpen}
                    from="edit-patient-dialog"
                    openModalInEditMode
                />
            )}
        </Fragment>
    );
};
